import { DropdownOption } from '../../definitions/formItem/ElementConfig';
var OptionType = /** @class */ (function () {
    function OptionType(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        this.display_type = obj.display_type;
    }
    Object.defineProperty(OptionType.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionType.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionType.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionType.prototype, "DisplayType", {
        get: function () {
            return this.display_type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OptionType.prototype, "DropDownOption", {
        get: function () {
            return new DropdownOption({
                label: this.bg_name,
                value: this.id
            });
        },
        enumerable: false,
        configurable: true
    });
    return OptionType;
}());
export { OptionType };
export function createOptionType(obj, id) {
    return new OptionType(obj, id);
}
export function createOptionTypes(rawTypes) {
    var types = [];
    var rawTypesData = rawTypes.data;
    for (var _i = 0, rawTypesData_1 = rawTypesData; _i < rawTypesData_1.length; _i++) {
        var rawType = rawTypesData_1[_i];
        var type = createOptionType(rawType.attributes, rawType.id);
        types.push(type);
    }
    return types;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/optionType/optionType.ts
// module id = 120
// module chunks = 0